var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.isLoading)?_c('div',[_c('ProfileSkeleton')],1):_c('ProfileWrapper',{attrs:{"id":"profile-documents","user":_vm.user,"candidate":_vm.candidate,"workAuthorizations":_vm.workAuthorizations,"score":_vm.profileScore,"disableScore":"","tabs":_vm.tabs}},[_c('CV')],1),_vm._v("\n    />\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }